import React, { useState, useEffect, useRef } from 'react';
import './faq.css';
import Footer from 'shared/components/footer/Footer';

const FAQ = ({ navbarHeight }) => {
  const footerRef = useRef(null);
  const windowHeight = window.innerHeight;
  const [faqPageHeight, setFaqPageHeight] = useState(0);
  const [bgHeight, setBgHeight] = useState(0);
  const faqMainRef = useRef(null);

  useEffect(() => {
    if (footerRef.current && faqMainRef) {
      const footerHeight = footerRef.current.offsetHeight;
      const faqheight = faqMainRef.current.offsetHeight;
      setFaqPageHeight(windowHeight - footerHeight - navbarHeight);
      setBgHeight(faqheight + navbarHeight);
    }
  }, [navbarHeight]);

  const [visibleQuestionIndex, setVisibleQuestionIndex] = useState(null);

  const toggleAnswerVisibility = (index) => {
    setVisibleQuestionIndex(visibleQuestionIndex === index ? null : index);
  };

  const faqData = [
    {
      question: "Who is behind CRYPTOxNFT?",
      answer: "CRYPTOXNFT is a crypto-focused team publishing market updates, educational resources, VIP context, and partner-based access flows for traders who want more structure."
    },
    {
      question: "What exchange do you use for trading?",
      answer: "You can study the market context on any exchange. Current copy trading and verification flows use the exchange links shown on the relevant service pages."
    },
    {
      question: "What kind of signals do you give?",
      answer: "VIP content may include spot and futures context, entries, targets, invalidation areas, and market commentary. Use all information with your own risk controls."
    },
    {
      question: "What kind of coins do you tend to give signals for?",
      answer: "The focus is crypto-first: large caps, active altcoins, and selected higher-risk opportunities when the setup quality is strong enough to discuss."
    },
    {
      question: "What is the win rate of your signals?",
      answer: "Past examples and reports are available on the site and in community channels, but past performance is not a guarantee. Review the historical proof before joining."
    },
    {
      question: "How often do you give signals?",
      answer: "Updates depend on market conditions. The goal is to avoid low-quality noise and publish context when there is a useful reason to pay attention."
    },
    {
      question: "Do you give exact entries, take profits, and stop losses?",
      answer: "Yes."
    },
    {
      question: "What time zone are you in?",
      answer: "Many updates are designed around broader market levels, so they are not always tied to a single local time zone. Always check the current message timestamp before acting."
    },
    {
      question: "Do you have any videos showing what your VIP looks like from the inside?",
      answer: "Yes. You can find previews on the VIP page and additional examples in the free Telegram group."
    }
  ];

  return (
    <div className='main-content'>
      <img 
        className='section1-bg' 
        src='./assets/images/backgrounds/bg1.png'
        style={{ height: `${bgHeight}px` }}
        alt="Background"
      />
      <div className='faq-main' ref={faqMainRef} style={{minHeight:`${faqPageHeight}px`}}>
        <h1 className='faq-header'>FAQ</h1>
        <div className='faq-content'>
          {faqData.map((item, index) => (
            <div key={index} className='faq-item'>
              <button
                type="button"
                className='faq-question' 
                onClick={() => toggleAnswerVisibility(index)}
                aria-expanded={visibleQuestionIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <span>{item.question}</span>
                <span className={`faq-arrow ${visibleQuestionIndex === index ? 'expanded' : ''}`}>
                  ▼
                </span>
              </button>
              <div id={`faq-answer-${index}`} className={`faq-answer ${visibleQuestionIndex === index ? 'expanded' : ''}`}>
                {item.answer}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='footer' ref={footerRef}><Footer/></div>
    </div>
  );
}

export default FAQ;
